import React, { Component } from "react";
import { Row, Col, Card, CardBody, UncontrolledTooltip } from "reactstrap";
import { Link, Redirect } from "react-router-dom";
import { isEmpty, size } from "lodash";
import { showToast } from '../../../UI/ui-toast'
import moment from "moment";
// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
    Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
//Import Breadcrumb
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { get_all_deleted_nominees_against_customer, restore_nominee } from '../../api/customersApi';
import RestoreModal from "components/Common/RestoreModal";
import default_avatar from "../../../../assets/images/avatar_01.png";
import { get_user_permissions } from "../../../../helpers/custom_helper"
var customerEdit, customerView, customerCreate, customerDelete, customerLog, customerRestore;
class DeletedNomineesList extends Component {
    constructor(props) {
        super(props);
        this.node = React.createRef();
        this.state = {
            page: 1,
            sizePerPage: 10,
            listData: [],
            listdata: "",
            viewmodal: false,
            modal: false,
            restoreModal: false,
            recordDeleteID: null,
            redirect: null
        };
        this.toggle = this.toggle.bind(this);
        this.onClickActivityLog = this.onClickActivityLog.bind(this);
    }
    componentDidMount() {
        customerEdit = get_user_permissions('customers-edit');
        customerView = get_user_permissions('customers-view');
        customerCreate = get_user_permissions('customers-create');
        customerDelete = get_user_permissions('customers-delete');
        customerLog = get_user_permissions('customer-logs-view');
        customerRestore = get_user_permissions('customers-restore');
        window.localStorage.removeItem('current_nominee_id')
        Promise.all([get_all_deleted_nominees_against_customer(window.localStorage.getItem("current_customer_id"))]).then((values) => {
            console.log(values[0]);
            this.setState({ listData: values[0] });
        });
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { listData } = this.props;
        if (!isEmpty(listData) && size(prevProps.listData) !== size(listData)) {
            this.setState({ listData: {}, isEdit: false });
        }
    }
    onPaginationPageChange = page => {
        if (
            this.node &&
            this.node.current &&
            this.node.current.props &&
            this.node.current.props.pagination &&
            this.node.current.props.pagination.options
        ) {
            this.node.current.props.pagination.options.onPageChange(page);
        }
    };
    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal,
        }));
    }
    toggleRestoreModal = () => {
        this.setState(prevState => ({
            restoreModal: !prevState.restoreModal,
        }));
    };
    onClickActivityLog = arg => {
        const listdata = arg;
        window.localStorage.setItem("current_nominee_id", listdata.id);
        this.setState({ redirect: "/customer/nominee/log" });
    }
    onClickRestore = listdata => {
        this.setState({ listdata: listdata });
        this.setState({ restoreModal: true });
    };
    handleRestore = () => {
        const { listdata } = this.state;
        if (listdata.id !== undefined) {
            console.log(listdata);
            console.log(this.state.recordDeleteID);
            Promise.all([restore_nominee(this.state.recordDeleteID)]).then((values) => {
                showToast("Success", "The nominee " + listdata.full_name + " has been restore successfully.", "success");
                this.setState({ redirect: "/customer/nominees/list" });
            }).catch((error) => {
                showToast("Failed", "Nominee Not Restored Successfully", "error");
            });
            this.setState({ restoreModal: false });
        }
    };
    render() {

        const { restoreModal } = this.state;

        const listdata = this.state.listdata;

        if (this.state.redirect) {
            return <Redirect to={this.state.redirect} />
        }
        const columns = [
            {
                dataField: "picture_path",
                text: "",
                sort: false,
                formatter: (cellContent, listdata) => (
                    <div>
                        <img src={listdata.picture_path == null ? default_avatar : listdata.picture_path} alt="" className="avatar-sm" />
                    </div>

                ),
            },
            {
                dataField: "full_name",
                text: "Name",
                sort: true,
            },
            {
                dataField: "country",
                text: "Country",
                sort: true,
            },
            {
                dataField: "city",
                text: "City",
                sort: true,
            },
            {
                dataField: "updated_name",
                text: "Updated By",
                sort: true,
            },
            {
                dataField: "updated_at",
                text: "Updated At",
                sort: true,
                formatter: (cellContent, listdata) => (
                    <>
                        {moment(listdata.updated_at).format('DD/MM/YYYY h:mma')}
                    </>

                ),
            },
            {
                dataField: "action",
                isDummyField: true,
                text: "Action",
                formatter: (cellContent, listdata) => (
                    <>
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            {customerView ? <>
                                {customerLog ? <>
                                    <li>
                                        <Link
                                            to="#"
                                            className="btn btn-sm btn-soft-primary"
                                            onClick={() => this.onClickActivityLog(listdata)}
                                        >
                                            <i className="mdi mdi-file-document-outline" id="logtooltip" />
                                            <UncontrolledTooltip placement="top" target="logtooltip">
                                                Activity Log
                                            </UncontrolledTooltip>
                                        </Link>
                                    </li>
                                </> : <></>}
                            </> : <></>}
                            {customerRestore ? <>
                                <li>
                                    <Link
                                        to="#"
                                        className="btn btn-sm btn-soft-success"
                                        onClick={() => this.onClickRestore(listdata)}
                                    >
                                        <i className="mdi mdi-restore" id="restoretooltip" />
                                        <UncontrolledTooltip placement="top" target="restoretooltip">
                                            Restore Nominee
                                        </UncontrolledTooltip>
                                    </Link>
                                </li>
                            </> : <></>}
                        </ul>
                    </>
                ),
            },
        ];

        const defaultSorted = [
            {
                dataField: "id",
                order: "asc",
            },
        ];
        const pageOptions = {
            sizePerPage: 10,
            custom: true,
        };
        const selectRow = {
            mode: "checkbox",
        };
        const { SearchBar } = Search;
        //meta title
        document.title = "List Customers";
        const rowEvents = {
            onClick: (e, row, rowIndex) => {
                this.setState({ recordDeleteID: row.id });
            }
        }
        return (
            <React.Fragment>
                <RestoreModal
                    show={restoreModal}
                    onDeleteClick={this.handleRestore}
                    record={`nominee`}
                    onCloseClick={() => this.setState({ restoreModal: false })}
                />
                <div className="page-content">
                    <div className="container-fluid">
                        <Breadcrumbs title="List Customer" breadcrumbItem="List Nominees" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <PaginationProvider
                                            pagination={paginationFactory(pageOptions)}
                                            keyField="id"
                                            columns={columns}
                                            data={this.state.listData}
                                        >
                                            {({ paginationProps, paginationTableProps }) => (
                                                <ToolkitProvider
                                                    keyField="id"
                                                    columns={columns}
                                                    data={this.state.listData}
                                                    search
                                                >
                                                    {toolkitProps => (
                                                        <React.Fragment>
                                                            <Row className="mb-2">
                                                                <Col md="4">
                                                                    <div className="search-box me-2 mb-2 d-inline-block">
                                                                        <div className="position-relative">
                                                                            <SearchBar
                                                                                {...toolkitProps.searchProps}
                                                                            />
                                                                            <i className="bx bx-search-alt search-icon" />
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="12">
                                                                    <div className="table-responsive">
                                                                        <BootstrapTable
                                                                            keyField={"id"}
                                                                            responsive
                                                                            bordered={false}
                                                                            striped={false}
                                                                            defaultSorted={defaultSorted}
                                                                            selectRow={selectRow}
                                                                            rowEvents={rowEvents}
                                                                            classes={
                                                                                "table align-middle table-nowrap"
                                                                            }
                                                                            headerWrapperClasses={"thead-light"}
                                                                            {...toolkitProps.baseProps}
                                                                            {...paginationTableProps}
                                                                            ref={this.node}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <Row className="align-items-md-center mt-30">
                                                                <Col className="inner-custom-pagination d-flex">
                                                                    <div className="d-inline">Results Per Page&nbsp;&nbsp;
                                                                        <SizePerPageDropdownStandalone
                                                                            {...paginationProps}
                                                                        />
                                                                    </div>
                                                                    <div className="text-md-right ms-auto">
                                                                        <PaginationListStandalone
                                                                            {...paginationProps}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </React.Fragment>
                                                    )}
                                                </ToolkitProvider>
                                            )}
                                        </PaginationProvider>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export default DeletedNomineesList;
